const readValue = (doc, key) => {
  if (!doc || !doc.data) return undefined;
  return doc.data[key];
};

export const validateMirrorPair = (baseDoc, mirrorDoc, expectedSeasonId, expectedTeamId) => {
  const issues = [];
  if (!baseDoc || !baseDoc.id || !baseDoc.data) {
    issues.push('BASE_MISSING');
    return { ok: false, issues, suggestedAction: 'WARN_ONLY' };
  }

  const baseMirrorId = readValue(baseDoc, 'mirrorId');
  const baseMatchGroupId = readValue(baseDoc, 'matchGroupId');
  const baseRecordStatus = readValue(baseDoc, 'recordStatus');

  if (!baseMatchGroupId) {
    issues.push('MATCH_GROUP_MISSING');
  }

  if (expectedTeamId) {
    const baseTeamId = readValue(baseDoc, 'teamId');
    if (baseTeamId && baseTeamId !== expectedTeamId) {
      issues.push('TEAM_MISMATCH');
    }
  }

  if (expectedSeasonId) {
    const baseSeasonId = readValue(baseDoc, 'seasonId');
    if (baseSeasonId && baseSeasonId !== expectedSeasonId) {
      issues.push('SEASON_MISMATCH');
    }
  }

  if (!mirrorDoc) {
    if (baseMirrorId) {
      issues.push('MIRROR_MISSING');
    }
    if (baseRecordStatus === 'LINKED') {
      issues.push('RECORD_STATUS_LINKED_WITHOUT_MIRROR');
    }
    const ok = issues.length === 0;
    return {
      ok,
      issues,
      suggestedAction: baseMirrorId ? 'ORPHAN_BASE' : 'WARN_ONLY'
    };
  }

  const mirrorMatchGroupId = readValue(mirrorDoc, 'matchGroupId');
  const mirrorRecordStatus = readValue(mirrorDoc, 'recordStatus');
  const mirrorMirrorId = readValue(mirrorDoc, 'mirrorId');

  if (baseMirrorId !== mirrorDoc.id || mirrorMirrorId !== baseDoc.id) {
    issues.push('MIRROR_ID_ASYMMETRIC');
  }

  if (baseMatchGroupId && mirrorMatchGroupId && baseMatchGroupId !== mirrorMatchGroupId) {
    issues.push('MATCH_GROUP_MISMATCH');
  }

  if (baseRecordStatus === 'LINKED' && !baseMirrorId) {
    issues.push('RECORD_STATUS_LINKED_WITHOUT_MIRROR');
  }

  if (mirrorRecordStatus === 'LINKED' && !mirrorMirrorId) {
    issues.push('RECORD_STATUS_LINKED_WITHOUT_MIRROR');
  }

  if (baseRecordStatus === 'ORPHAN' && baseMirrorId) {
    issues.push('RECORD_STATUS_ORPHAN_HAS_MIRROR');
  }

  if (expectedTeamId) {
    const mirrorTeamId = readValue(mirrorDoc, 'teamId');
    if (mirrorTeamId && mirrorTeamId !== expectedTeamId) {
      issues.push('TEAM_MISMATCH');
    }
  }

  if (expectedSeasonId) {
    const mirrorSeasonId = readValue(mirrorDoc, 'seasonId');
    if (mirrorSeasonId && mirrorSeasonId !== expectedSeasonId) {
      issues.push('SEASON_MISMATCH');
    }
  }

  const ok = issues.length === 0;
  let suggestedAction = 'WARN_ONLY';
  if (issues.includes('MIRROR_MISSING') || issues.includes('RECORD_STATUS_LINKED_WITHOUT_MIRROR')) {
    suggestedAction = 'ORPHAN_BASE';
  } else if (issues.includes('MIRROR_ID_ASYMMETRIC') || issues.includes('MATCH_GROUP_MISMATCH')) {
    suggestedAction = 'REPAIR_LINK';
  }

  return { ok, issues, suggestedAction };
};
